function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { NavAction } from '../../Actions';
function MobileRightActions(props) {
  const {
    rightActions,
    isMobile
  } = props;
  return rightActions.map((action, index) => {
    return /*#__PURE__*/React.createElement(NavAction, _extends({
      key: index
    }, action, {
      isMobile: isMobile
    }));
  });
}
MobileRightActions.defaultProps = {
  rightActions: [],
  isMobile: false
};
MobileRightActions.propTypes = {
  rightActions: PropTypes.array,
  isMobile: PropTypes.bool
};
export default MobileRightActions;